import { render, staticRenderFns } from "./EditorName.vue?vue&type=template&id=11d28046&scoped=true&"
import script from "./EditorName.vue?vue&type=script&lang=ts&"
export * from "./EditorName.vue?vue&type=script&lang=ts&"
import style0 from "./EditorName.vue?vue&type=style&index=0&id=11d28046&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d28046",
  null
  
)

export default component.exports